/**
 * outboxStorage — où une file d'envoi garde ses références : `AsyncStorage` (le stockage de
 * l'appareil, `localStorage` sur le web). Une interface, pour qu'un test passe le sien.
 */
import AsyncStorage from "@react-native-async-storage/async-storage"

export type KeyValueStorage = {
    getItem: (key: string) => Promise<string | null>
    setItem: (key: string, value: string) => Promise<void>
}

export const defaultKeyValueStorage: KeyValueStorage = {
    getItem: (key) => AsyncStorage.getItem(key),
    setItem: (key, value) => AsyncStorage.setItem(key, value),
}
